export class Diamond {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.size = 16;
    this.rotation = 0;
    this.rotationSpeed = 0.1;
  }

  update(speed) {
    // Simple frame-based movement
    this.x -= speed;
    this.rotation += this.rotationSpeed;
  }

  draw(ctx) {
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.rotate(this.rotation);
    
    // Draw diamond shape
    ctx.fillStyle = '#00bcd4';
    ctx.strokeStyle = '#0097a7';
    ctx.lineWidth = 2;
    
    ctx.beginPath();
    ctx.moveTo(0, -this.size);
    ctx.lineTo(this.size, 0);
    ctx.lineTo(0, this.size);
    ctx.lineTo(-this.size, 0);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
    
    // Draw sparkle
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(-2, -this.size - 2, 4, 4);
    ctx.fillRect(this.size - 2, -2, 4, 4);
    ctx.fillRect(-2, this.size - 2, 4, 4);
    ctx.fillRect(-this.size - 2, -2, 4, 4);
    
    ctx.restore();
  }
}

